import React from 'react';
import { Layout } from '../components/Layout/Layout';

export const Home: React.FC = () => {
  return (
    <Layout>
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '60vh',
        textAlign: 'center',
        color: 'var(--text-secondary)'
      }}>
        <h1 style={{ fontSize: '2em', marginBottom: '16px', color: 'var(--text-primary)' }}>
          Welcome to OverlookDocs
        </h1>
        <p style={{ fontSize: '1.1em', maxWidth: '500px' }}>
          Select a document from the navigation tree on the left to view it, or press <kbd style={{
            background: 'var(--bg-tertiary)',
            padding: '2px 8px',
            borderRadius: '4px',
            border: '1px solid var(--border)',
            fontFamily: 'monospace'
          }}>Ctrl+O</kbd> to search.
        </p>
      </div>
    </Layout>
  );
};
